import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { CreditCard, ArrowLeft, AlertCircle } from "lucide-react";
import { useCompanyAccount } from "@/hooks/useCompanyAccount";
import { CompanyBillingTab } from "@/components/company-settings/CompanyBillingTab";
import { DeleteAccountCard } from "@/components/settings/DeleteAccountCard";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function BillingPage() {
  usePageMeta({
    title: "Billing & Account | LaneRunner",
    fullTitle: true,
    description: "Manage your LaneRunner subscription, payment method, and account deletion.",
  });


  const { company, subscription, loading } = useCompanyAccount();

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 space-y-6">
      <Link
        to="/profile-settings"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Settings
      </Link>

      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
          <CreditCard className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-foreground">Billing & Account</h1>
          <p className="text-sm text-muted-foreground">
            Subscription, payment method, and account deletion
          </p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center min-h-[30vh]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
        </div>
      ) : company ? (
        <CompanyBillingTab company={company} subscription={subscription} hideSeats={true} />
      ) : (
        <Card className="p-6 text-center">
          <AlertCircle className="h-8 w-8 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">
            No subscription is linked to this account yet.
          </p>
        </Card>
      )}

      <DeleteAccountCard />
    </div>
  );
}
